import ReactScrollbar from './react-scrollbar';

export default ReactScrollbar;



// WEBPACK FOOTER //
// ./src/index.js